import React, { useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { IoEye, IoEyeOff } from "react-icons/io5";

const FormAddUser = () => {

    const [name, setName] = useState("")
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [confPassword, setConfPassword] = useState("")
    const [role, setRole] = useState("")
    const [msg, setMsg] = useState("")

    const navigate = useNavigate();

    const [passwordType, setPasswordType] = useState("password");
    const [confPasswordType, setConfPasswordType] = useState("password");

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    const toggleConfPassword = () => {
        if (confPasswordType === "password") {
            setConfPasswordType("text")
            return;
        }
        setConfPasswordType("password")
    }

    axios.defaults.withCredentials = true;

    const saveUser = async (e) => {
        e.preventDefault();
        try {
            await axios.post('https://ayres-iot-backend.cyclic.app/users', {
                name: name,
                username: username,
                password: password,
                confPassword: confPassword,
                role: role
            })
            navigate("/users")
        } catch (error) {
            if (error.response) {
                setMsg(error.response.data.msg);
            }
        }
    }

    return (
        <div><h1 className='title'>Users</h1>
            <h2 className='subtitle'>Add New User</h2>

            <div className="column is-4 is-offset-4">
                <div className="content box">
                    <form onSubmit={saveUser}>
                        {msg && <div className="notification is-danger is-light">
                            {msg}
                        </div>}
                        <div className="field">
                            <label className="label">Name</label>
                            <div className="control">
                                <input type="text" className="input" value={name} onChange={(e) => setName(e.target.value)} placeholder='Name' />
                            </div>
                        </div>
                        <div className="field">
                            <label className="label">Username</label>
                            <p className="control has-icons-right">
                                <input type="text" className="input" value={username} onChange={(e) => setUsername(e.target.value)} placeholder='Username' />

                            </p>
                        </div>
                        <label className="label">Password</label>
                        <div className="field has-addons">
                            <div className="control is-expanded">
                                <input type={passwordType} className="input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder='*****' />
                            </div>
                            <div className="control">
                                <p className="button is-success" onClick={togglePassword}>
                                    {passwordType === "password" ? <IoEye /> : <IoEyeOff />}
                                </p>
                            </div>
                        </div>
                        <label className="label">Confirm Password</label>
                        <div className="field has-addons">
                            <div className="control is-expanded">
                                <input type={confPasswordType} className="input" value={confPassword} onChange={(e) => setConfPassword(e.target.value)} placeholder='*****' />
                            </div>
                            <div className="control">
                                <p className="button is-success" onClick={toggleConfPassword}>
                                    {confPasswordType === "password" ? <IoEye /> : <IoEyeOff />}
                                </p>
                            </div>
                        </div>
                        <div className="field">
                            <label className="label">Select Role</label>
                            <div className="control">
                                <div className="select is-fullwidth">
                                    <select value={role} onChange={(e) => setRole(e.target.value)}>
                                        <option value="">--- Pick Role ---</option>
                                        <option value="admin">Admin</option>
                                        <option value="user">User</option>
                                    </select>
                                </div>

                            </div>
                        </div>
                        <div className="field">
                            <div className='control'></div>
                            <button type="submit" className="button is-success">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    )
}

export default FormAddUser